<template>
  <section class="housemaid-quote-info">
    <template  v-if="isEndorsement">
      <div
        v-for="(item,index) in compareData"
        :key="index"
        class="box">
        <span
          v-if="item.isSpan"
          class="title">{{item.title}}</span>
        <h3 v-if="!item.isBold&&item.title&&!item.isSpan">{{ item.title }}</h3>
        <h2 v-if="item.isBold&&item.title&&!item.isSpan">{{ item.title }}</h2>
        <div
          class="table"
          :class="item.class" >
          <div
            v-for="(sumItem,sumIndex) in item.list"
            v-show="sumItem.type!='array' || !sumItem.notShow"
            :key="sumIndex"
            class="tr">
            <span>{{ sumItem.name }}</span>
            <span v-if="formData[sumItem.field] === oldForm[sumItem.field]">
              {{ showCompare(sumItem, formData[sumItem.field]) }}
            </span>
            <span
              v-else
              class="compare">
              <span class="text-line color-danger">
                {{ showCompare(sumItem, oldForm[sumItem.field]) }}
              </span>
              <span class="color-success">
                {{ showCompare(sumItem, formData[sumItem.field]) }}
              </span>
            </span>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        v-for="(item,index) in compareData"
        :key="index"
        class="box">
        <span
          v-if="item.isSpan"
          class="title">{{item.title}}</span>
        <h3 v-if="!item.isBold&&item.title&&!item.isSpan">{{ item.title }}</h3>
        <h2 v-if="item.isBold&&item.title&&!item.isSpan">{{ item.title }}</h2>
        <div
          class="table"
          :class="item.class" >
          <div
            v-for="(sumItem,sumIndex) in item.list"
            v-show="!sumItem.notShow"
            :key="sumIndex"
            class="tr">
            <span>{{ sumItem.name }}</span>
            <span
              v-if="sumItem.type == 'array'"
            >
              <span
                v-for="(sum,index) in sumItem.value"
                :key="'sum'+index"
                v-copy="sum.name">{{sum.name}}<br></span>
            </span>
            <span
              v-else
              v-copy="showCompare(sumItem, formData[sumItem.field])">
              <span  v-if="sumItem.type == 'value'">{{ sumItem.value }}</span>
              <span v-else>{{ showCompare(sumItem, formData[sumItem.field]) }}</span>
              <email-tooltip
                v-if="sumItem.field == 'email'"
                :email="formData.email"></email-tooltip>
            </span>
          </div>
        </div>
      </div>
    </template>
  </section>
</template>
<script>
import dayjs from 'dayjs'
import MixinOptions from '@/mixins/options'
import OMath from '@/utils/math'
import {mapActions, mapState} from 'vuex'

export default {
  name: 'HousemaidQuoteInfo',
  mixins: [MixinOptions],
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    title: {
      type: Boolean,
      default: true
    },
    oldForm: {
      type: Object,
      default: () => ({})
    },
    isEndorsement: {
      type: Boolean,
      default: false
    },
    isQuote: {
      type: Boolean,
      default: false
    },
    showCompany:{
      type: Boolean,
      default: false
    }
  },
  data(){
    return{
      // compareData:
    }
  },
  computed: {
    ...mapState('common', ['nationalityOptions']),
    compareData() {
      let {quote_coverage_list={}} = this.formData||{}
      let benefitsList = this[`allOptions${this.formData.class_id}`].benefits || []
      let arr =[]
      if(benefitsList.length > 0){
        arr = benefitsList.filter(item => {
          return this.formData.benefits.includes(item.id)
        })
      }
      return [
        {
          title: '',
          class:'mg-b-10',
          list:
            [
              {
                name: 'Expected Effective Date',
                field: 'pcy_cmnt_date',
                type:'value',
                value:this.formData.is_eff_dt_delay&&this.isQuote?'ASAP':`${this.formData.pcy_cmnt_date} ${this.formData.is_eff_dt_delay&&!this.isQuote?'(ASAP)':''}`
              },
              {
                name: 'Period of Insurance',
                field: 'period_of_cvr',
                fieldCode: 'period',
                option: 21
              },
              {
                name: 'Expected Expiry Date',
                field: 'pcy_expry_date',
              },
              {
                name: 'Coverage',
                field: 'coverage_id',
                option: 10,
              },
              {
                name: 'Optional Benefits',
                field: 'benefits',
                type:'array',
                value:arr
              },
              {
                name: 'Insurer',
                field: 'company_language',
                notShow:!this.showCompany
              },
            ]
        },
        {
          title: 'Policyholder Detail',
          isBold:true,
          list: [
            {
              name: 'Title',
              field: 'isrd_title',
              fieldCode: 'titleOptions',
              option: 1
            },
            {
              name: 'Occupation',
              field: 'occ',
              // field: 'occ_id',
              // fieldCode: 'occupation',
              // option: 21,
            },
            {
              name: 'Last Name',
              field: 'isrd_lst_nm'
            }, {
              name: 'First Name',
              field: 'isrd_fst_nm'
            },
            {
              name: 'Mobile Number',
              field: 'mobile_no',
            },
            {
              name: 'Date of Birth',
              field: 'isrd_dob_date',
            },
            {
              name: this.formData.id_type_language,
              field: 'id_no'
            },
            {
              name: 'Nationality',
              field: 'id_nationality_seq_language',
              notShow: this.formData.id_type == 1
            },
            {
              name: 'Email',
              field: 'email',
            },
          ],
        },
        {
          title:'Proposed Location of Risk',
          isSpan:true,
          list:[
            {
              name:'Room',
              field:'addr_room'
            },     {
              name:'Floor',
              field:'addr_floor'
            },     {
              name:'Block',
              field:'addr_block'
            },     {
              name:'Building / Estate',
              field:'addr_building'
            },{
              name:'Street',
              field:'addr_street'
            },{
              name:'District',
              field:'addr_district',
              isAddress:true,
              addressCode: 'district'
            },{
              name:'Area',
              field:'addr_area',
              isAddress:true,
              addressCode: 'area',
            },{
              name:'Country / Region',
              field:'addr_region',
              isAddress:true,
              addressCode:'region'
            },
          ]
        },
        {
          title: 'Correspondence Address',
          isBold: false,
          isSpan:true,
          list: [
            {
              name: 'Is your Correspondence Address same as Proposed Location of Risk?',
              field: 'is_addr_same_ind',
              fieldCode: 'yesNoOptions',
              option: 1

            },
            {
              name: 'Room',
              field: 'cor_addr_room'
            },
            {
              name: 'Floor',
              field: 'cor_addr_floor'
            }, {
              name: 'Block',
              field: 'cor_addr_block'
            }, {
              name: 'Building / Estate',
              field: 'cor_addr_building'
            }, {
              name: 'Street',
              field: 'cor_addr_street'
            }, {
              name: 'District',
              field: 'cor_addr_district',
              isAddress: true,
              addressCode: 'district'
            }, {
              name: 'Area',
              field: 'cor_addr_area',
              isAddress: true,
              addressCode: 'area'
            }, {
              name: 'Country / Region',
              field: 'cor_addr_region',
              isAddress: true,
              addressCode: 'region'
            },
          ]
        },
        {
          title: 'Domestic Helper’s Information',
          isBold: true,
          list: [
            {
              name: 'Title',
              field: 'domestic_title',
              fieldCode: 'titleOptions',
              option: 1,
            },
            // {
            //   name: 'Name',
            //   field: 'full_name',
            // },
            {
              name: 'Last Name',
              field: 'domestic_lst_nm',
            },
            {
              name: 'First Name',
              field: 'domestic_fst_nm',
            },
            {
              name: 'HKID/Passport Number',
              field: 'domestic_id_no',
            },
            {
              name: 'Position/Duties',
              field: 'duty_id',
              option: 21,
              fieldCode: 'duties'
            },
            {
              name: 'Date of Birth',
              field: 'domestic_dob_date',
            },
            {
              name: 'Nationality',
              field: 'nationality_id',
              option: 21,
              fieldCode: 'nationality'
            },
            {
              name: 'Monthly Salary',
              field: 'monthly_salary',
              isMoney:true
            },
            // {
            //   name: 'Monthly Salary',
            //   field: 'monthly_salary',
            //   option: 1
            // },
          ]
        }
      ]
    },
    pcy_end_dt() {
      const { period_of_cvr, pcy_cmnt_dt } = this.formData
      if(pcy_cmnt_dt && period_of_cvr) {
        if(period_of_cvr >= 1) {
          return dayjs(pcy_cmnt_dt).add(period_of_cvr, 'years').format('YYYY-MM-DD')
        }
        else {
          return dayjs(pcy_cmnt_dt).add(Number(period_of_cvr)*10, 'months').format('YYYY-MM-DD')
        }
      }
      return ''
    },
    localAllOptions() {
      return this.allOptions21
    },
    isDoula() {
      const { duty_id } = this.formData
      const data = this.getOptionData('', duty_id, this.localAllOptions.duties)
      const { doula } = data || {}
      return doula === 1
    },
    salaryOptions() {
      const { salary } = this.localAllOptions
      const { doula = [], others = [] } = salary || {}
      if(this.isDoula) {
        return doula
      }
      return others
    },
    coverageOptions() {
      const { coverage = [] } = this.localAllOptions
      if(this.isPartTime) {
        return coverage.filter(item => item.part_time === 1)
      }
      if(this.isDriver) {
        return coverage.filter(item => item.id === 2)
      }
      return coverage
    },
  },
  watch: {
    'formData.nationality_id': {
      immediate: true,
      deep: true,
      handler(val) {
        if(val) {
          this.updateNationalityOptions(val)
        }
      }
    }
  },
  methods: {
    ...mapActions('common', ['updateNationalityOptions']),
    getName(id){
      let data = this.coverageOptions.filter(item=>{
        return item.id==id
      })
      return data.length>0?data[0].name:''
    },
    showCompare(item, field) {
      var change = field
      if(item.field == 'nationality_id') {
        const result = this.getOptionName('', field, this.nationalityOptions)
        if(result) return result
        return this.getAllOptionName21('nationality', field)
      }
      if (item.option) {
        switch (item.option) {
          case 1:
            change = this.getOptionName(item.fieldCode, field)
            break
          case 10:
            change = this.getName(field)
            break
          case 21:
            change = this.getAllOptionName21(item.fieldCode, field)
            break
          case 24:
            change = this.getAllOptionName24(item.fieldCode, field)
            break
          case 26:
            change = this.getAllOptionName26(item.fieldCode, field)
            break
        }
      }
      if (item.isAddress) {
        change = this.getAreaName(item.addressCode, field)
      }
      if (item.isSum) {
        change = OMath.formatMoney(field, 2, true) + 'HK$'
      }
      if (item.isMoney){
        // change = change +'HKD'
        if(change == 0) {
          change = '-'
        }
        else {
          change = OMath.formatMoney(field, 2, true)
        }
      }
      if(item.field =='pcy_end_dt')
        change = this.pcy_end_dt
      return change
    }
  }
}
</script>
<style lang="scss" scoped>
.housemaid-quote-info{
  .box {
    margin-bottom: 15px;
  }
  .title {
    display: block;
    padding-bottom: 15px;
    font-size: 16px;
    font-weight: 400;
    color: #616266;
  }
  .table {
    .tr {
      .compare {
        display: flex;
        align-items: center;
        & > span {
          flex: 1;
        }
      }
    }
  }
  .asap{
    font-weight: bold;
    color: black;
    margin-left: 5px;
  }
}
</style>
